// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"checkboxes__yUwKp","h3":"h3__okiiu","inputError":"inputError__KD66V"};